import React from 'react';
import classnames from 'classnames';
import { ThumbnailProductImage } from 'scy/ProductImage';
import { TextButton } from 'scy/buttons';
import { QuantityPicker } from 'scy/Input';
import CartItemEngraving from './engraving';
import PromoIcon from 'images/icons/tag.svg?react-svg';
import {
  sansSerifMedium,
  sansSerifLight,
  fontSizeXS,
  lineHeightS,
  highlight
} from 'scy/text/styles.mod.scss';
import {
  textLeft,
  textRight,
  textOverflow,
  maxWidth100,
  strikethrough
} from 'scy/utils.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './list.mod.scss';

export default function ListItem({
  item,
  engraving,
  checkout,
  loading,
  onClick,
  remove,
  updateQty,
  removeEngraving,
  updateEngraving,
  ariaLabel
}) {
  return (
    <li
      className={classnames(margin.bottom_sm, fontSizeXS, lineHeightS, {
        [styles.unavailable]: !item.price || item.soldout
      })}
    >
      <ThumbnailProductImage
        product={item}
        onClick={onClick ? () => onClick(item) : null}
        className={styles.thumbnail}
      />

      <div className={flex}>
        <Info
          onClick={onClick ? () => onClick(item) : null}
          title={item.title}
          subtitle={item.subtitle}
          volume={item.volume}
          remove={() => remove(item, { checkout })}
        />

        <div className={`${textRight} ${sansSerifMedium} ${fontSizeXS}`}>
          <QuantityPicker
            ariaLabel={`${ariaLabel} ${item.qty}`}
            defaultValue={item.qty}
            min={1}
            onChange={qty =>
              qty ? updateQty(item, qty, { checkout }) : Promise.resolve()
            }
            className={margin.bottom_xs}
            disabled={!item.price || loading}
          />
          <Price
            subtotal={item.subtotal}
            originalSubtotal={item.originalSubtotal}
          />
        </div>
      </div>

      {!!engraving && (
        <CartItemEngraving
          item={item}
          engraving={engraving}
          updateEngraving={engraving =>
            updateEngraving(item, engraving, { checkout })
          }
          removeEngraving={engraving =>
            removeEngraving(engraving, { checkout })
          }
          disabled={loading}
          checkout={checkout}
        />
      )}
    </li>
  );
}

function Info({ onClick, title, subtitle, volume, remove }) {
  return (
    <div
      className={`${flex1} ${sansSerifLight} ${textOverflow} ${
        margin.right_xs
      }`}
    >
      <div className={sansSerifMedium}>
        <TextButton
          noUnderline
          className={`${textLeft} ${textOverflow} ${maxWidth100}`}
          onClick={onClick}
        >
          {title}
        </TextButton>
      </div>
      <div className={textOverflow}>{subtitle}</div>
      <div>{volume}</div>
      <TextButton onClick={remove}>Remove</TextButton>
    </div>
  );
}

function Price({ subtotal = 0, originalSubtotal = 0 }) {
  if (originalSubtotal > subtotal) {
    return (
      <>
        <div className={highlight}>
          <PromoIcon width={10} height={10} /> ${subtotal.toFixed(2)}
        </div>
        <div className={strikethrough}>${originalSubtotal.toFixed(2)}</div>
      </>
    );
  } else {
    return <div>{subtotal ? '$' + subtotal.toFixed(2) : 'Unavailable'}</div>;
  }
}
